<template>
  <layout :tenantId="'dummytenantforlogintest'">
    <main aria-label="Login test">
      <h1>Login test</h1>
      <button v-if="!displayName" class="primary" @click="login()">Start login</button>
      <span v-else>Use Logout button from upper corner to logout.</span>
    </main>
  </layout>
</template>

<script lang="ts" setup>

import layout from './layout.vue';
import { ESignCommonClient } from './esignclient';
import { computed, onMounted } from 'vue';
import { ensureUser, userStore } from '@/userStore';

function login() {

  const lastPart = window.location.pathname.split('/').pop();
  const url = '/api/dummytenantforlogintest/.signin/'+ lastPart + '?ReturnUrl=' + encodeURIComponent(window.location.pathname+window.location.search);
  window.location.href = url;
}

const displayName = computed(() => userStore.loginInfo.displayName);

  const client = new ESignCommonClient();
async function loadUser() {
  await ensureUser('dummytenantforlogintest');
}
async function logout() {  
  const logoutResult = await client.logout('dummytenantforlogintest');
  if(logoutResult.logoutUrl) {
    //include search since that might include the language
    const redirectUrl =  window.location.pathname+window.location.search;
    window.location.href = logoutResult.logoutUrl + '?ReturnUrl=' + encodeURIComponent(redirectUrl);
  }
  await loadUser();
}

onMounted(() => {
  loadUser();
});
</script>

<style src="./sign2.css"/>
